module.exports = __webpack_public_path__ + "static/media/festival_05.cb64b293.jpg";